module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-42.16bd25d4.png";